import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { fetchOrganizationApi } from './organization.service';


export const fetchOrganization = createAsyncThunk(
  'organization/fetchOrganization',
  async (organizationName: string, { rejectWithValue }) => {
    try {
      const response = await fetchOrganizationApi(organizationName);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch organization data');
    }
  }
);

// Define the state interface
export interface OrganizationState {
  data: any | null; // Replace with the actual response type
  loading: boolean;
  error: string | null;
  message: string | null;
}

// Initial state
const initialState: OrganizationState = {
  data: null,
  loading: false,
  error: null,
  message: null,
};

// Create the slice
const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
    clearOrganizationData: (state) => {
      state.data = null;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganization.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(fetchOrganization.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload;
        state.message = 'Organization data fetched successfully';
        state.error = null;
      })
      .addCase(fetchOrganization.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.data = null;
        state.message = null;
      });
  },
});

// Export actions
export const { clearError, clearMessage, clearOrganizationData } = organizationSlice.actions;

// Export reducer
export default organizationSlice.reducer;